import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import BasicInfo from '../../../../../jobseeker-collect-additional-information/components/BasicInfo';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';
import {
  KEY_PROFILE_FIELDS,
  keyProfileFieldsPropTypes,
} from '../../../screenTypeSchema';

import screenTypeTelemetry from '../screenTypeTelemetry';

import './KeyProfileFields.less';

export function KeyProfileFields({
  applyData,
  onError,
  onScreenTypeFinish,
  screenTypeParameters,
  setIsLoading,
}) {
  const {
    ip_country_code: ipCountryCode,
    location_autocomplete_url: locationAutocompleteUrl,
  } = screenTypeParameters;

  const {
    logView,
    logFinish,
  } = screenTypeTelemetry(KEY_PROFILE_FIELDS, applyData);

  // log initial screen view
  useEffect(() => {
    logView();
  }, [logView]);

  const handleScreenTypeFinish = async () => {
    logFinish();
    await onScreenTypeFinish();
  };

  return (
    <div className="KeyProfileFields">
      <BasicInfo
        header="We used your resume to make a profile for you, but need a little more information."
        ipCountryCode={ipCountryCode}
        locationAutocompleteUrl={locationAutocompleteUrl}
        onError={onError}
        onSubmit={handleScreenTypeFinish}
        salaryNote={(
          <>
            {'This information will be used to help match you to relevant jobs. '}
            <strong>It will not be shared with employers.</strong>
          </>
        )}
        submitText="Continue"
        setIsLoading={setIsLoading}
      />
    </div>
  );
}

KeyProfileFields.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onError: PropTypes.func.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenTypeParameters: keyProfileFieldsPropTypes.isRequired,
  setIsLoading: PropTypes.func,
};

KeyProfileFields.defaultProps = {
  setIsLoading: () => {},
};

export default KeyProfileFields;
